import { render } from "./confirmarEnvio.vue?vue&type=template&id=e7a613fa"
import script from "./confirmarEnvio.vue?vue&type=script&lang=js"
export * from "./confirmarEnvio.vue?vue&type=script&lang=js"

import "./confirmarEnvio.vue?vue&type=style&index=0&id=e7a613fa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__